class RelatedShopRestrictionStrategy extends StrategyListener
	constructor: (StrategyFactory, @AuthenticationService) ->
		super()

		@ConfigurationService = StrategyFactory.ConfigurationService
		@UserInformation = StrategyFactory.UserInformation

	apply: (type, query) ->
		if @AuthenticationService.isLoggedIn()
			status = @ConfigurationService.isEnabled('Backoffice.UserManagement.ShowOnlyFromRelatedShops')
		else
			status = false

		@listen 'UserRepository', status

		if !@listening type
			return query

		user = @UserInformation.getSubUser()

		if !user?
			return query

		query.with 'shops'
		query.criteria 'shops.id', 'IN', user.shops.join()

		return query
